export const MIN_SEARCH_LENGTH = 2
